import { isEmpty } from "lodash";
import React, { useState } from "react";
import { services } from "../../api";
import { Loader } from "../Utils/Loader";
import { useSelector, useDispatch } from "react-redux";
import { setLoader } from "../../actions/Header";

export const GetStatus = () => {
  const [refId, setRefId] = useState("");
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrorMsg] = useState("");
  const [statusRes, setStatusRes] = useState({});
  const { loader } = useSelector((state) => state.HeaderReducer);
  const dispatch = useDispatch();

  const onSubmitHandler = async () => {
    if (refId.length > 0) {
      setErrorMsg("");
      let first3Character = refId.substring(0, 3);
      let after3Character = refId.substring(3);
      let regx = false;

      if (
        (first3Character.toLowerCase() === "cff" ||
          first3Character.toLowerCase() === "ctf") &&
        !isNaN(after3Character)
      ) {
        regx = true;
      }

      if (regx) {
        setLoading(true);
        let res = await services.getFaultStatus(
          `faultstatus?tab=${first3Character}&id=${after3Character}`,
          "get"
        );
        setLoading(false);
        if (res?.statusCode == 200) {
          let statusRef = { ...res.body };

          setStatusRes(statusRef);
        } else {
          let statusRef = { ...statusRes };
          statusRef.notFoundMsg = res.body.status;
          setStatusRes(statusRef);
        }
      } else {
        setErrorMsg("Please search valid Reference Number");
      }
    } else {
      setErrorMsg("Please enter the reference number.");
    }
  };

  const onClearHandler = () => {
    setStatusRes({});
    setRefId("");
    setErrorMsg("");
  };

  if (loading) {
    return <Loader />;
  }
  return (
    <form
      autoComplete="false"
      className="form-container getSugg-form four-form"
    >
      <div className="container">
        <div className="row m-b-25">
          <div className="input-field  col s12  ">
            <small className="red-text f-16"></small>
            <input
              onChange={(e) => setRefId(e.target.value)}
              type="text"
              value={refId}
              className="validate c-input m-b-0 mb-0"
              id="Refnumber"
              name="Refnumber"
              placeholder="Reference number"
            />
            {errMsg.length ? (
              <span className="error-message">{errMsg}</span>
            ) : (
              <></>
            )}
          </div>
        </div>

        <div className="row">
          <div
            className="col s6 offset-s3 center-align"
            style={{ textAlign: "center" }}
          >
            <button
              className="waves-effect waves-light theme-btn light-blue darken-3 btn col s12 mt-4"
              style={{ width: "50%" }}
              type="button"
              onClick={onSubmitHandler}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
      {!isEmpty(statusRes) && (
        <div id="modal1" className="modal modal-open">
          <div className="modal-content p-0 modal-content-body">
            {statusRes.notFoundMsg ? (
              <div
                className="alert-icon"
                id="error-icon"
                style={{ display: "block" }}
              >
                <i className="fa fa-exclamation-circle"></i>
              </div>
            ) : (
              <div id="success-icon" style={{ display: "block" }}></div>
            )}
            <div align="center" style={{ padding: "20px" }}>
              <p id="modalMessage">
                {statusRes.notFoundMsg ? (
                  statusRes.notFoundMsg
                ) : (
                  <>
                    <h6 className="modal-reference">Reference Number</h6>
                    <h4 className="ref-number">
                      <b>{statusRes.refNumber}</b>
                    </h4>
                    <div className="col s6">
                      --------------------------------------------------------------
                      <h5 className="modal-status">Status</h5>
                      <h4 className="ref-status">{statusRes.status}</h4>
                    </div>
                  </>
                )}
              </p>

              <div className="col s6">
                <button
                  className="waves-effect waves-light theme-btn light-blue darken-3 btn col s12 ok-btn getstatusbtn"
                  type="button"
                  onClick={onClearHandler}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </form>
  );
};
